(function () {
  'use strict';

  var CONFIG_SECTION_ID = 'needledust-special-cart-drawer-config';
  var config = normalizeConfig(window.NeedledustSpecialCartDrawerConfig || {});

  var EYEBROW_TEXT = config.eyebrowText;
  var OFFER_TEXT = config.offerText;
  var CODE_LABEL = config.codeLabel;
  var DISCOUNT_CODE = config.discountCode;
  var BUTTON_TEXT = config.buttonText;
  var CHECKOUT_REDIRECT = config.checkoutRedirect;
  var TIMER_SECONDS = config.timerSeconds;
  var POLL_MS = 15000;
  var ROOT_ID = 'needledust-special-cart-drawer';
  var STYLE_ID = 'needledust-special-cart-drawer-style';
  var SESSION_CLOSED_KEY = 'needledustSpecialCartDrawerClosed';
  var SESSION_EXPIRED_KEY = 'needledustSpecialCartDrawerExpired';

  var state = {
    initialized: false,
    active: false,
    cartHasItems: false,
    visible: false,
    timerStarted: false,
    remaining: TIMER_SECONDS,
    intervalId: null,
    pollId: null,
    lastCartCheck: 0
  };

  function textSetting(value, fallback) {
    var text = typeof value === 'string' ? value.trim() : '';
    return text || fallback;
  }

  function positiveIntegerSetting(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function booleanSetting(value, fallback) {
    if (value === true || value === 'true') {
      return true;
    }
    if (value === false || value === 'false') {
      return false;
    }
    return fallback;
  }

  function normalizeConfig(source) {
    return {
      enabled: booleanSetting(source.enabled, true),
      eyebrowText: textSetting(source.eyebrowText, 'Specially for you'),
      offerText: textSetting(source.offerText, '10% discount'),
      codeLabel: textSetting(source.codeLabel, 'Code:'),
      discountCode: textSetting(source.discountCode, 'special10'),
      buttonText: textSetting(source.buttonText, 'Claim'),
      checkoutRedirect: textSetting(source.checkoutRedirect, '/checkout'),
      timerSeconds: positiveIntegerSetting(source.timerSeconds, 180)
    };
  }

  function applyConfig(nextConfig) {
    config = normalizeConfig(Object.assign({}, config, nextConfig || {}));
    EYEBROW_TEXT = config.eyebrowText;
    OFFER_TEXT = config.offerText;
    CODE_LABEL = config.codeLabel;
    DISCOUNT_CODE = config.discountCode;
    BUTTON_TEXT = config.buttonText;
    CHECKOUT_REDIRECT = config.checkoutRedirect;
    TIMER_SECONDS = config.timerSeconds;

    if (!state.timerStarted) {
      state.remaining = TIMER_SECONDS;
    }
  }

  function loadSectionConfig() {
    return window.fetch('/?sections=' + encodeURIComponent(CONFIG_SECTION_ID) + '&ndscd=' + Date.now(), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Drawer config request failed');
        }
        return response.json();
      })
      .then(function (sections) {
        var html = sections && sections[CONFIG_SECTION_ID];
        if (!html) {
          return null;
        }

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var element = doc.querySelector('[data-needledust-special-cart-drawer-config]');
        if (!element) {
          return null;
        }

        return {
          enabled: element.dataset.enabled,
          eyebrowText: element.dataset.eyebrowText,
          offerText: element.dataset.offerText,
          codeLabel: element.dataset.codeLabel,
          discountCode: element.dataset.discountCode,
          buttonText: element.dataset.buttonText,
          checkoutRedirect: element.dataset.checkoutRedirect,
          timerSeconds: element.dataset.timerSeconds
        };
      });
  }

  function canUseSessionStorage() {
    try {
      var testKey = '__needledust_special_test__';
      window.sessionStorage.setItem(testKey, '1');
      window.sessionStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  var sessionEnabled = canUseSessionStorage();

  function getSessionFlag(key) {
    if (!sessionEnabled) {
      return false;
    }
    return window.sessionStorage.getItem(key) === '1';
  }

  function setSessionFlag(key) {
    if (sessionEnabled) {
      window.sessionStorage.setItem(key, '1');
    }
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '#' + ROOT_ID + ' {',
      '  position: fixed;',
      '  top: 50%;',
      '  right: 16px;',
      '  width: min(300px, calc(100vw - 32px));',
      '  transform: translate(116%, -50%);',
      '  opacity: 0;',
      '  pointer-events: none;',
      '  z-index: 2147483000;',
      '  transition: transform 320ms ease, opacity 220ms ease;',
      '  font-family: inherit;',
      '}',
      '#' + ROOT_ID + '.is-visible {',
      '  transform: translate(0, -50%);',
      '  opacity: 1;',
      '  pointer-events: auto;',
      '}',
      '#' + ROOT_ID + ' .nd-special-card {',
      '  position: relative;',
      '  border: 1px solid rgba(35, 31, 32, 0.14);',
      '  border-radius: 8px;',
      '  background: #fffaf5;',
      '  color: #231f20;',
      '  box-shadow: 0 18px 45px rgba(35, 31, 32, 0.18);',
      '  padding: 18px;',
      '}',
      '#' + ROOT_ID + ' .nd-special-close {',
      '  position: absolute;',
      '  top: 8px;',
      '  right: 8px;',
      '  width: 28px;',
      '  height: 28px;',
      '  border: 0;',
      '  border-radius: 50%;',
      '  background: transparent;',
      '  color: #4c3a32;',
      '  cursor: pointer;',
      '  font-size: 21px;',
      '  line-height: 28px;',
      '  padding: 0;',
      '}',
      '#' + ROOT_ID + ' .nd-special-close:hover,',
      '#' + ROOT_ID + ' .nd-special-close:focus-visible {',
      '  background: rgba(35, 31, 32, 0.08);',
      '  outline: none;',
      '}',
      '#' + ROOT_ID + ' .nd-special-eyebrow {',
      '  margin: 0 24px 8px 0;',
      '  font-size: 13px;',
      '  line-height: 1.3;',
      '  letter-spacing: 0;',
      '  font-weight: 700;',
      '}',
      '#' + ROOT_ID + ' .nd-special-title {',
      '  margin: 0 0 8px;',
      '  font-size: 25px;',
      '  line-height: 1.12;',
      '  letter-spacing: 0;',
      '  font-weight: 700;',
      '}',
      '#' + ROOT_ID + ' .nd-special-code {',
      '  margin: 0 0 12px;',
      '  font-size: 14px;',
      '  line-height: 1.4;',
      '}',
      '#' + ROOT_ID + ' .nd-special-code strong {',
      '  display: inline-block;',
      '  border: 1px dashed rgba(35, 31, 32, 0.28);',
      '  border-radius: 6px;',
      '  background: #ffffff;',
      '  padding: 3px 8px;',
      '  letter-spacing: 0;',
      '}',
      '#' + ROOT_ID + ' .nd-special-row {',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: space-between;',
      '  gap: 12px;',
      '}',
      '#' + ROOT_ID + ' .nd-special-timer {',
      '  min-width: 58px;',
      '  font-variant-numeric: tabular-nums;',
      '  font-size: 18px;',
      '  line-height: 1;',
      '  font-weight: 700;',
      '}',
      '#' + ROOT_ID + ' .nd-special-claim {',
      '  min-height: 42px;',
      '  border: 0;',
      '  border-radius: 6px;',
      '  background: #231f20;',
      '  color: #ffffff;',
      '  cursor: pointer;',
      '  font: inherit;',
      '  font-size: 14px;',
      '  font-weight: 700;',
      '  line-height: 1;',
      '  padding: 0 18px;',
      '  white-space: nowrap;',
      '}',
      '#' + ROOT_ID + ' .nd-special-claim:hover,',
      '#' + ROOT_ID + ' .nd-special-claim:focus-visible {',
      '  background: #000000;',
      '  outline: none;',
      '}',
      '@media (max-width: 699px) {',
      '  #' + ROOT_ID + ' {',
      '    right: 12px;',
      '    width: min(286px, calc(100vw - 24px));',
      '  }',
      '  #' + ROOT_ID + ' .nd-special-card {',
      '    padding: 16px;',
      '  }',
      '  #' + ROOT_ID + ' .nd-special-title {',
      '    font-size: 22px;',
      '  }',
      '}',
      '@media (prefers-reduced-motion: reduce) {',
      '  #' + ROOT_ID + ' {',
      '    transition: none;',
      '  }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function buildDrawer() {
    var existing = document.getElementById(ROOT_ID);
    if (existing) {
      return existing;
    }

    injectStyle();

    var drawer = document.createElement('aside');
    drawer.id = ROOT_ID;
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-live', 'polite');
    drawer.setAttribute('aria-label', 'Special discount');

    drawer.innerHTML = [
      '<div class="nd-special-card">',
      '  <button class="nd-special-close" type="button" aria-label="Close">×</button>',
      '  <p class="nd-special-eyebrow">' + escapeHtml(EYEBROW_TEXT) + '</p>',
      '  <p class="nd-special-title">' + escapeHtml(OFFER_TEXT) + '</p>',
      '  <p class="nd-special-code">' + escapeHtml(CODE_LABEL) + ' <strong>' + escapeHtml(DISCOUNT_CODE) + '</strong></p>',
      '  <div class="nd-special-row">',
      '    <span class="nd-special-timer" data-nd-special-timer>03:00</span>',
      '    <button class="nd-special-claim" type="button">' + escapeHtml(BUTTON_TEXT) + '</button>',
      '  </div>',
      '</div>'
    ].join('');

    drawer.querySelector('.nd-special-close').addEventListener('click', function () {
      setSessionFlag(SESSION_CLOSED_KEY);
      hideDrawer();
    });

    drawer.querySelector('.nd-special-claim').addEventListener('click', function () {
      window.location.href = '/discount/' + encodeURIComponent(DISCOUNT_CODE) + '?redirect=' + encodeURIComponent(CHECKOUT_REDIRECT);
    });

    document.body.appendChild(drawer);
    return drawer;
  }

  function escapeHtml(value) {
    var element = document.createElement('span');
    element.textContent = value;
    return element.innerHTML;
  }

  function formatTime(seconds) {
    var safeSeconds = Math.max(0, seconds);
    var minutes = Math.floor(safeSeconds / 60);
    var remainder = safeSeconds % 60;
    return String(minutes).padStart(2, '0') + ':' + String(remainder).padStart(2, '0');
  }

  function updateTimer() {
    var timer = document.querySelector('#' + ROOT_ID + ' [data-nd-special-timer]');
    if (timer) {
      timer.textContent = formatTime(state.remaining);
    }
  }

  function expireDrawer() {
    setSessionFlag(SESSION_EXPIRED_KEY);
    hideDrawer();
  }

  function startTimer() {
    if (state.timerStarted) {
      return;
    }

    state.timerStarted = true;
    updateTimer();
    state.intervalId = window.setInterval(function () {
      state.remaining -= 1;
      updateTimer();
      if (state.remaining <= 0) {
        window.clearInterval(state.intervalId);
        expireDrawer();
      }
    }, 1000);
  }

  function showDrawer() {
    if (state.visible || getSessionFlag(SESSION_CLOSED_KEY) || getSessionFlag(SESSION_EXPIRED_KEY)) {
      return;
    }

    var drawer = buildDrawer();
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-visible');
      state.visible = true;
      startTimer();
    });
  }

  function hideDrawer() {
    var drawer = document.getElementById(ROOT_ID);
    if (drawer) {
      drawer.classList.remove('is-visible');
    }
    state.visible = false;
  }

  function maybeShowDrawer() {
    if (state.active && state.cartHasItems && document.visibilityState !== 'hidden') {
      showDrawer();
    }
  }

  function checkCart(force) {
    var now = Date.now();
    if (!force && now - state.lastCartCheck < 1000) {
      return;
    }
    state.lastCartCheck = now;

    window.fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart request failed');
        }
        return response.json();
      })
      .then(function (cart) {
        state.cartHasItems = Number(cart.item_count || 0) >= 1;
        if (!state.cartHasItems) {
          hideDrawer();
        }
        maybeShowDrawer();
      })
      .catch(function () {
        state.cartHasItems = false;
      });
  }

  function markActive() {
    if (!state.active) {
      state.active = true;
    }
    checkCart(false);
  }

  function bindActivity() {
    ['click', 'keydown', 'mousemove', 'scroll', 'touchstart'].forEach(function (eventName) {
      window.addEventListener(eventName, markActive, { passive: true });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'hidden') {
        markActive();
      }
    });

    window.addEventListener('focus', markActive);

    ['cart:change', 'cart:updated', 'cart:refresh', 'product:added', 'variant:add'].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        state.active = true;
        window.setTimeout(function () {
          checkCart(true);
        }, 600);
      });
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
        state.active = true;
        window.setTimeout(function () {
          checkCart(true);
        }, 1200);
      }
    }, true);
  }

  function initialize() {
    if (state.initialized) {
      return;
    }

    state.initialized = true;

    if (config.enabled === false) {
      hideDrawer();
      return;
    }

    ready(function () {
      if (getSessionFlag(SESSION_CLOSED_KEY) || getSessionFlag(SESSION_EXPIRED_KEY)) {
        return;
      }

      bindActivity();
      checkCart(true);

      state.pollId = window.setInterval(function () {
        if (document.visibilityState !== 'hidden') {
          checkCart(true);
        }
      }, POLL_MS);
    });
  }

  loadSectionConfig()
    .then(function (sectionConfig) {
      applyConfig(sectionConfig);
      initialize();
    })
    .catch(function () {
      initialize();
    });
})();
